import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Collapse } from '@as/cotopaxi';
import { DateFormat, ReturnedSaleStatusTypes } from '@as-react/common-types';
import { Box, Divider, Stack, TextAlpha } from '@yonderland/andes-react';
import dayjs from 'dayjs';
import { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { ordersActions } from '../../redux/orders/actions/OrdersActions.creators';
import { makeGetReturnedSales } from '../../redux/orders/selectors/OrdersSelectors';
import { makeGetLoggedInState, makeGetSessionState } from '../../redux/session/selectors/SessionSelector';
import { AnnouncedReturn } from './AnnouncedReturn';
import { ReturnItemsEmptyState } from './ReturnItemsEmptyState';
export const AnnouncedReturns = ({ configuredReturnOptions }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const dispatch = useDispatch();
    const loggedIn = useSelector(makeGetLoggedInState());
    const sessionState = useSelector(makeGetSessionState());
    const returnedSales = useSelector(makeGetReturnedSales());
    useEffect(() => {
        dispatch(analyticsActions.returnPortalAnnouncedOverviewOpened());
    }, []);
    useEffect(() => {
        if (!sessionState.authorities) {
            return;
        }
        dispatch(ordersActions.getReturnedSales());
        dispatch(ordersActions.getReturnReasons());
    }, [sessionState, loggedIn]);
    return (returnedSales === null || returnedSales === void 0 ? void 0 : returnedSales.length) ? (_jsx(_Fragment, { children: returnedSales.map((returnedSale, index) => {
            let readableDate = '';
            if (returnedSale.date) {
                readableDate = `${dayjs(returnedSale.date).format(DateFormat.DD_MM_YYYY_DASH)} `;
            }
            const collapseTitle = (_jsx(Box, { marginInline: { base: '-4', md: '0' }, paddingInlineEnd: { base: '10', md: '7' }, children: _jsxs(Stack, { justify: "between", align: "center", children: [_jsxs(TextAlpha, { as: "h4", variant: "subheadingS", children: [readableDate, t('returnItems.registeredReturns.return'), " #", returnedSale.announcementReference ? returnedSale.announcementReference : returnedSale.saleId] }), _jsx(TextAlpha, { variant: "bodyS", alignment: "end", children: returnedSale.statusMessage === ReturnedSaleStatusTypes.COMPLETED
                                ? t('returnItems.registeredReturns.status.completed')
                                : t('returnItems.registeredReturns.status.inProcess') })] }) }));
            return (_jsxs(Fragment, { children: [index === 0 && (_jsx(Box, { marginInline: { base: '-4', md: '0' }, children: _jsx(Divider, {}) })), _jsx(Collapse, { id: `announced-returns-collapse-${index}`, title: collapseTitle, withOverflow: true, mobileFullwidth: true, open: returnedSale.statusMessage !== ReturnedSaleStatusTypes.COMPLETED, hasDivider: false, labelFullWidth: true, children: _jsx(AnnouncedReturn, { configuredReturnOptions: configuredReturnOptions, returnedSale: returnedSale }) }, index), _jsx(Box, { marginInline: { base: '-4', md: '0' }, children: _jsx(Divider, {}) })] }, index));
        }) })) : (_jsx(ReturnItemsEmptyState, { message: t('returnItems.registeredReturns.emptyState.message') }));
};
